import React from 'react';
import { Link } from 'react-router-dom';

import PublicLayout from '../../components/public/PublicLayout';
import { Button } from '../../components/ui/button';
import { NotFoundSeo } from '../../seo/Seo';

const LINKS = [
  { label: 'Donut menu', to: '/menu' },
  { label: 'Wholesale supply', to: '/wholesale' },
  { label: 'Catering', to: '/catering' },
  { label: 'Where to find us', to: '/where-to-find-us' },
];

const NotFound = () => (
  <PublicLayout testId="public-not-found">
    <NotFoundSeo />
    <section className="pt-24 pb-28 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-amber-50 to-white">
      <div className="max-w-2xl mx-auto text-center">
        <p className="mb-4 text-sm font-semibold uppercase tracking-widest text-amber-600">404</p>
        <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">That page has moved</h1>
        <p className="text-lg text-gray-600 mb-10">
          The link is broken or the page no longer exists. Everything we bake and supply is one click away.
        </p>
        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="rounded-full border border-amber-200 bg-white px-5 py-2.5 text-sm font-medium text-gray-700 hover:border-amber-400 transition-colors"
            >
              {link.label}
            </Link>
          ))}
        </div>
        <Button asChild size="lg" className="bg-gray-900 text-white hover:bg-gray-800 px-8">
          <Link to="/" data-testid="not-found-home-cta">Back to the home page</Link>
        </Button>
      </div>
    </section>
  </PublicLayout>
);

export default NotFound;
